// Import environment variables from Next.js runtime

// Import core MUI components for layout and styling
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import { env } from 'next-runtime-env'

// Import custom components for typography, styling and avatar
import { Avatar } from '@/components/atoms/avatar'
import Indicator from '@/components/atoms/indicator'
import { MvTypography } from '@/components/atoms/mv-typography'
// Import custom types for handling notification data
import { NotificationItemProps } from '../types/Notification.type'
// Import utility functions for calculating time difference
import { timeDiff } from '../utils'

export function NotificationItem({ size, notif, handleReadSingle = () => {} }: NotificationItemProps) {
  const theme = useTheme()

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      onClick={() => handleReadSingle(notif.id)}
      sx={{
        gap: 2,
        padding: 4,
        borderBottom: `1px solid ${theme.colorToken.border.neutral.normal}`,
        backgroundColor: theme.colorToken.background.neutral.normal,
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: notif.is_read
            ? theme.colorToken.background.primary.disabled
            : theme.colorToken.background.neutral.subtlest
        }
      }}
    >
      <Stack direction='row' sx={{ gap: 2 }}>
        <Box sx={{ flexBasis: '20px' }}>
          <Avatar
            type={notif.sender?.avatar ? 'image' : 'initial'}
            size={size === 'small' ? 'xs' : 'sm'}
            isAsync={false}
            displayName={`${notif.sender?.first_name} ${notif.sender?.last_name}`}
            src={`${env('NEXT_PUBLIC_REST_API_URL')}/assets/${notif.sender?.avatar}`}
          />
        </Box>
        <Stack sx={{ gap: 1 }}>
          <MvTypography size='BODY_MD_NORMAL' typeSize='PX'>
            <span style={{ fontWeight: 'bold' }}>
              {notif.sender?.first_name} {notif.sender?.last_name}{' '}
            </span>
            {notif.message}
          </MvTypography>
          {notif.content && notif.content}
          <MvTypography size='BODY_SM_NORMAL' typeSize='PX' color={theme.colorToken.text.neutral.subtle}>
            {timeDiff(notif.timestamp)}
          </MvTypography>
        </Stack>
      </Stack>
      {!notif.is_read && (
        <Box sx={{ flexBasis: '12px' }}>
          <Indicator color='primary' size='small' />
        </Box>
      )}
    </Stack>
  )
}
